// Keilani Clothing — Onam Collection data (v2)
// Product photography lives in /public/collection ; reviews in /public/reviews

export const BRAND = {
  name: "Keilani",
  suffix: "Clothing",
  instagram: "https://www.instagram.com/keilani_clothing/",
  instagramHandle: "@keilani_clothing",
  whatsapp: "https://wa.me/918137921196",
  whatsappNumber: "+91 81379 21196",
  founder: "Anjali",
  quote:
    "Every lady's most loved handcrafted cotton dress brand — where every stitch tells a story. We create breathable, hand-embroidered dresses for the modern Indian woman who wants to feel beautiful, comfortable and connected to the craft.",
};

export const SHIPPING_BANNER = "Shipping All Over The World";

export const COLLECTION_CAPTION =
  "Slow-made pieces for the festival of harvest — woven by hand, cut to your measure.";

export const ONAM_INTRO =
  "Inspired by the quiet elegance of Kerala's festive season, each piece embraces simplicity in its purest form — breathable cotton, delicate floral embroidery and a subtle golden kasavu border.";

export const CATEGORIES = {
  bloom: {
    id: "bloom",
    label: "Bloom Everyday",
    kicker: "Bloom Everyday · Softly hand-embroidered",
    headingA: "Softly worn,",
    headingB: "quietly loved.",
    caption: "Hand-embroidered cotton to slip into any ordinary day — and let it bloom.",
    body: "A softer everyday — pintucks, tiny floral embroideries, delicate lace finishes and gentle silhouettes. Made for the woman who finds beauty in the quiet things.",
    verse: "light & uncomplicated",
  },
  onam: {
    id: "onam",
    label: "Onam Collection",
    kicker: "The Onam Collection · Festive Cotton",
    headingA: "Woven for",
    headingB: "the festival.",
    caption: "Slow-made pieces for the festival of harvest — cut to your measure.",
    body: "Inspired by the quiet elegance of Kerala's festive season, each piece embraces simplicity in its purest form — breathable cotton, delicate floral embroidery and a subtle golden kasavu border.",
    verse: "woven for the harvest",
  },
  everyday: {
    id: "everyday",
    label: "Everyday Collection",
    kicker: "The Everyday Collection · Made to be worn",
    headingA: "Made for",
    headingB: "the everyday.",
    caption: "Handcrafted cotton dresses to slip into any ordinary day and make it a little softer.",
    body: "Breathable cotton, hand-embroidered detailing and thoughtful silhouettes — the pieces our customers reach for again and again.",
    verse: "soft, slow, everyday",
  },
};

export const PRODUCTS = [
  {
    id: "nora",
    index: "01",
    name: "Nora",
    meaning: "a quiet blue afternoon",
    tagline: "Pintuck front · contrast florals",
    price: 2980,
    priceNote: "Sleeves +₹150 · Cotton · Courier charges extra",
    category: "bloom",
    colours: "Blue with yellow florals — custom tones on request",
    verse: "light & uncomplicated",
    description:
      "A soft blue cotton dress with delicate pintuck detailing across the front, finished with contrast yellow floral embroidery for a subtle pop of colour. The gently gathered skirt gives it an easy, flowy silhouette — made for relaxed, breezy days.",
    features: [
      "Breathable blue cotton",
      "Delicate pintuck front",
      "Contrast yellow floral embroidery",
      "Softly gathered skirt",
    ],
    cover: "/collection/nora-1.jpg",
    video: "/videos/nora.mp4",
    gallery: [
      "/collection/nora-1.jpg",
      "/collection/nora-2.jpg",
      "/collection/nora-3.jpg",
    ],
    span: "tall",
  },
  {
    id: "meadowmint",
    index: "02",
    name: "Meadowmint",
    meaning: "a fresh breath of green",
    tagline: "Smocked yoke · frilled neckline · matching bottom",
    price: 2995,
    priceNote: "Sleeves +₹150 · Cotton · Courier charges extra",
    category: "bloom",
    colours: "Also available in soft blush — DM us",
    verse: "softened with details that reveal themselves slowly",
    description:
      "A breezy cotton co-ord in a soft mint shade, detailed with delicate smocking embroidery on the yoke, subtle frills along the neckline and contrast lace finishing the hemline. Paired with a matching bottom carrying the same delicate details.",
    features: [
      "Breathable mint cotton",
      "Hand-smocked embroidery yoke",
      "Frilled neckline",
      "Contrast lace hem",
      "Matching bottom included",
    ],
    cover: "/collection/meadowmint-1.jpg",
    gallery: [
      "/collection/meadowmint-1.jpg",
      "/collection/meadowmint-2.jpg",
      "/collection/meadowmint-3.jpg",
    ],
    span: "wide",
  },
  {
    id: "bluebell",
    index: "03",
    name: "Bluebell",
    meaning: "soft as a whisper",
    tagline: "Pintuck cape · tie straps · lace hem",
    price: 2790,
    priceNote: "Sleeves +₹150 · Cotton · Courier charges extra",
    category: "bloom",
    colours: "Also available in ivory — DM us",
    verse: "the front & the back details",
    description:
      "A soft blue cotton dress with a pintuck cape, delicate floral embroidery and adjustable tie straps. Finished with dainty lace detailing along the hem for that extra touch of charm.",
    features: [
      "Breathable blue cotton",
      "Pintuck cape overlay",
      "Delicate floral embroidery",
      "Adjustable tie straps",
      "Dainty lace hem",
    ],
    cover: "/collection/bluebell-1.jpg",
    video: "/videos/bluebell.mp4",
    gallery: [
      "/collection/bluebell-1.jpg",
      "/collection/bluebell-2.jpg",
      "/collection/bluebell-3.jpg",
    ],
    span: "tall",
  },
  {
    id: "hazel",
    index: "04",
    name: "Hazel",
    meaning: "warm earth, gentle bloom",
    tagline: "Off-white embroidery · lace hem",
    price: 2680,
    priceNote: "Sleeves +₹150 · Cotton · Courier charges extra",
    category: "bloom",
    colours: "Custom warm tones on request — DM us",
    verse: "quiet, warm, softly worn",
    description:
      "A brown cotton dress with delicate off-white floral embroidery that adds a gentle contrast to the warm brown base, while the lace detailing along the hem brings in a pretty, delicate finish.",
    features: [
      "Warm brown cotton",
      "Off-white hand-floral embroidery",
      "Delicate lace hem",
      "Gentle, everyday silhouette",
    ],
    cover: "/collection/hazel-1.jpg",
    gallery: [
      "/collection/hazel-1.jpg",
      "/collection/hazel-2.jpg",
    ],
    span: "wide",
  },
  {
    id: "iris",
    index: "05",
    name: "Iris",
    meaning: "the one they keep coming back for",
    tagline: "Pintuck bodice · scattered florals",
    price: 2550,
    priceNote: "Sleeves +₹150 · Cotton · Courier charges extra",
    badge: "Bestseller",
    category: "everyday",
    colours: "Also available in cream — DM us",
    description:
      "Our most-loved cotton dress — a flowing black silhouette scattered with tiny hand-embroidered florals, soft pintucks and a whisper of a ribbon tie at the back. Breezy, effortless, endlessly re-orderable — no wonder it keeps returning to our customers' wardrobes.",
    features: [
      "Breathable cotton",
      "Delicate pintuck bodice",
      "Hand-embroidered floral motifs",
      "Soft ribbon tie at the back",
    ],
    cover: "/collection/iris-3.jpg",
    video: "/videos/iris.mp4",
    gallery: [
      "/collection/iris-3.jpg",
      "/collection/iris-1.jpg",
      "/collection/iris-2.jpg",
      "/collection/iris-4.jpg",
    ],
    span: "tall",
  },
  {
    id: "mira",
    index: "06",
    name: "Mira",
    meaning: "a quiet wonder",
    tagline: "Sunlit cotton · French knot detail",
    price: 2999,
    priceNote: "Cotton · Courier charges extra",
    badge: "Designer's Favourite",
    category: "everyday",
    colours: "Also available in ivory — DM us",
    description:
      "A sunlit ode to slow mornings. Mira is an easy, breathable cotton dress with delicate pintucks, hand-embroidered florals and fine French knot detailing along the armholes. Anjali's own favourite — the piece she reaches for when the day needs a smile.",
    features: [
      "Breathable cotton",
      "Delicate pintucks",
      "Hand-embroidered florals",
      "French knot detailing at the armhole",
    ],
    cover: "/collection/mira-1.jpg",
    video: "/videos/mira.mp4",
    gallery: [
      "/collection/mira-1.jpg",
      "/collection/mira-3.jpg",
      "/collection/mira-2.jpg",
    ],
    span: "wide",
  },
  {
    id: "kanikonna",
    index: "07",
    name: "Kanikonna",
    meaning: "the golden Onam bloom",
    tagline: "Brocade yoke · yellow & mint",
    price: 2850,
    priceNote: "Cotton · Courier charges extra",
    category: "onam",
    colours: "Custom festive tones on request — DM us",
    description:
      "Inspired by the vibrant colours of a blooming pookkalam, Kanikonna is a celebration of Onam in its most graceful form. Crafted in soft cotton, this flowing silhouette is elevated with a woven brocade yoke in festive shades of sunshine yellow and mint green. Gentle pleats beneath the yoke add movement and ease — timeless, and effortlessly elegant.",
    features: [
      "Breathable cotton",
      "Brocade yoke inspired by the season",
      "Soft pleated silhouette",
    ],
    cover: "/collection/kanikonna-1.jpg",
    video: "/videos/kanikonna.mp4",
    gallery: [
      "/collection/kanikonna-1.jpg",
      "/collection/kanikonna-2.jpg",
      "/collection/kanikonna-3.jpg",
    ],
    span: "tall",
  },
  {
    id: "malar",
    index: "08",
    name: "Malar",
    meaning: "the blossom",
    tagline: "Cross-stitch florals · kasavu hem",
    price: 2850,
    priceNote: "Sleeves +₹150 · Cotton · Courier charges extra",
    category: "onam",
    colours: "Also available in pastel green — DM us",
    description:
      "Gentle as a blooming flower and timeless as an Onam tradition, Malar is designed for moments you'll always remember. A softly gathered cream cotton silhouette scattered with tiny hand-stitched florals, finished with a golden kasavu hem that catches the festive light.",
    features: [
      "Soft breathable cotton",
      "Hand cross-stitch floral motifs",
      "Golden kasavu hem",
    ],
    cover: "/collection/malar-1.jpg",
    video: "/videos/pookalam-malar.mp4",
    gallery: [
      "/collection/malar-1.jpg",
      "/collection/malar-2.jpg",
      "/collection/malar-3.jpg",
      "/collection/malar-4.jpg",
    ],
    span: "wide",
  },
  {
    id: "pookkaalam",
    index: "09",
    name: "Pookkaalam",
    category: "onam",
    colours: "Custom festive tones on request — DM us",
    meaning: "the floral carpet",
    tagline: "Tie-knot · scalloped lace hem",
    price: 2880,
    priceNote: "Sleeves +₹150 · Cotton · Courier charges extra",
    description:
      "Inspired by the gentle blooms that brighten every Onam morning, Pookkaalam is crafted in soft, breathable cotton for celebrations that deserve both comfort and elegance. Delicate floral embroidery adds charm, while the statement tie-knot detailing brings a contemporary twist to a timeless silhouette — finished with a beautifully scalloped lace hemline.",
    features: [
      "Soft cotton fabric",
      "Delicate floral embroidery",
      "Statement tie-knot detailing",
      "Scalloped lace hemline",
    ],
    cover: "/collection/pookkaalam-1.jpg",
    video: "/videos/pookalam-malar.mp4",
    gallery: [
      "/collection/pookkaalam-1.jpg",
      "/collection/pookkaalam-2.jpg",
      "/collection/pookkaalam-3.jpg",
    ],
    span: "tall",
  },
  {
    id: "thumbapoo",
    index: "10",
    name: "Thumbapoo",
    category: "onam",
    colours: "Also available in cream — DM us",
    meaning: "the sacred white bloom",
    tagline: "Textured yoke · kasavu sleeves",
    price: 2750,
    priceNote: "Cotton · Courier charges extra",
    description:
      "Some traditions never fade — they simply become more beautiful with time. Thumbapoo is crafted in airy cotton with a softly gathered silhouette, complemented by an intricately detailed yoke. The classic kasavu borders on the sleeves and hemline bring a timeless festive touch — a piece you'll reach for every Onam.",
    features: [
      "Breathable cotton comfort",
      "Textured handcrafted yoke",
      "Kasavu sleeve & hemline detailing",
    ],
    cover: "/collection/thumbapoo-1.jpg",
    video: "/videos/thumbapoo.mp4",
    gallery: [
      "/collection/thumbapoo-1.jpg",
      "/collection/thumbapoo-2.jpg",
      "/collection/thumbapoo-3.jpg",
    ],
    span: "wide",
  },
];

export const HERO_IMAGE = "/collection/thumbapoo-1.jpg";

export const VALUES = [
  { label: "Handmade", icon: "hand" },
  { label: "Sustainable", icon: "leaf" },
  { label: "Small Batch", icon: "package" },
  { label: "Fair Wages", icon: "scale" },
  { label: "Made in India", icon: "globe" },
];

export const SIZE_CHART = {
  headers: ["Size", "Bust", "Waist", "Hip"],
  rows: [
    ["XS", 32, 30, 38],
    ["S", 34, 32, 40],
    ["M", 36, 34, 42],
    ["L", 38, 36, 44],
    ["XL", 40, 38, 46],
    ["XXL", 42, 40, 48],
    ["3XL", 44, 42, 52],
    ["4XL", 46, 44, 54],
  ],
};

export const REVIEW_QUOTES = [
  {
    text: "Received my order — it's really beautiful. I can't describe in words… simply awesome.",
    author: "Instagram customer",
  },
  {
    text: "Perfect stitching, really up to my expectations or maybe more. It didn't need any alterations — my husband and siblings loved it a lot.",
    author: "Happy customer",
  },
  {
    text: "Both the dresses are absolutely beautiful. Fits really well, loved the embroidery on the soft breathable fabric. Thank you for the easy, hassle-free shopping experience.",
    author: "Repeat customer",
  },
  {
    text: "All your designs are very classy and minimal… I'm in love with most of your designs.",
    author: "Instagram",
  },
  {
    text: "Second order… and so much trust.",
    author: "Returning customer",
  },
  {
    text: "Beautiful customer Tatjana, all the way from Germany.",
    author: "International order",
  },
];

export const REVIEW_SHOTS = [
  "/reviews/review1.jpg",
  "/reviews/review2.jpg",
  "/reviews/review3.jpg",
  "/reviews/review4.jpg",
  "/reviews/review5.jpg",
  "/reviews/review6.jpg",
  "/reviews/review7.jpg",
  "/reviews/review8.jpg",
  "/reviews/review9.jpg",
];

export const STATS = [
  { value: "1000+", label: "Satisfied Customers" },
  { value: "5000+", label: "Successful Orders" },
  { value: "100%", label: "Handcrafted to Order" },
];

export const STATS_TAGLINE =
  "Most who wear Keilani come back for more — that quiet loyalty is what sets us apart.";

export const CONTACT = {
  unit: {
    city: "Ernakulam",
    label: "Production Unit",
    lines: ["Ponnurunni Rd, Vytilla", "Ernakulam, Kerala 682020"],
  },
  store: {
    name: "Yarntree Multibrand Store",
    city: "Thrissur",
    label: "Also available at",
    lines: [
      "Aristo Rd, near Jubilee Mission Hospital",
      "Fathima Nagar, East Fort, Nellikunnu",
      "Thrissur, Kerala 680005",
    ],
    instagram: "https://www.instagram.com/yarntree_multibranded_store",
    instagramHandle: "@yarntree_multibranded_store",
  },
};

export const STOCKIST = {
  name: "Yarntree Multibrand Store",
  note: "Find Keilani on the racks at our stockist partner.",
  instagram: "https://www.instagram.com/yarntree_multibranded_store",
  instagramHandle: "@yarntree_multibranded_store",
};

export const PRODUCTION_UNITS = [
  {
    city: "Ernakulam",
    lines: ["Ponnurunni Rd, Vytilla", "Ernakulam, Kerala 682020"],
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Handmade",
    body: "Every piece is cut, stitched and hand-embroidered by our small team. The tiny irregularities are the signature of a human hand, not a machine.",
  },
  {
    no: "02",
    title: "Sustainable",
    body: "Breathable natural cottons and low-waste patterning. We make only what we can make well, keeping the footprint as gentle as the cloth.",
  },
  {
    no: "03",
    title: "Made Slow",
    body: "Nothing is rushed. Each garment takes the time it takes — produced in small batches, the way clothing used to be made.",
  },
  {
    no: "04",
    title: "Custom Fit",
    body: "Sizes are yours to choose — XS through 4XL, or tailored to your own measure. Tell us your fit and we make it for you.",
  },
];
